export const MSG_NO_ITEMS = 'Não há itens.';
export const INFO_SHORTCUT_KEYS = 'Pressione `/` para pesquisar e `N` para criar um novo item.';
export const INFO_CANCEL_SHORTCUT_KEY = 'Pressione `Esc` para cancelar.';



// WEBPACK FOOTER //
// ./src/assets/text/en_US.js